import { OrthographicCamera, Scene, WebGLRenderer } from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { DEFAULT_DIRECTIONAL_VECTOR } from '../utils/constants';

export default class CameraBoxRenderingContext {
  public scene: Scene;
  public camera: OrthographicCamera;
  public renderer: WebGLRenderer;
  public cameraControls: OrbitControls;

  constructor(
    scene: Scene,
    camera: OrthographicCamera,
    renderer: WebGLRenderer,
    cameraControls: OrbitControls,
  ) {
    this.scene = scene;
    this.camera = camera;
    this.renderer = renderer;
    this.cameraControls = cameraControls;
  }

  public static get(containerElement: HTMLElement) {
    const scene = new Scene();
    const camera = new OrthographicCamera(-3.5, 3.5, 3.5, -3.5, 0.1, 1000);
    const renderer = new WebGLRenderer({ antialias: true, alpha: true });
    renderer.setSize(130, 130);
    const controls = new OrbitControls(camera, renderer.domElement);
    controls.enableZoom = false;
    controls.enablePan = false;
    camera.position
      .copy(controls.target)
      .add(DEFAULT_DIRECTIONAL_VECTOR.clone().multiplyScalar(5.5));
    controls.update();

    containerElement.appendChild(renderer.domElement);

    return new CameraBoxRenderingContext(scene, camera, renderer, controls);
  }
}
